import { AppResources } from "@/constants.ts";

const OnboardingHeader = () => {
  return (
    <div className="onboarding-header">
      <img src={AppResources.logo} alt="Smartwiz logo" />
    </div>
  );
};

export default OnboardingHeader;
